import { Box, Button, Tab, Tabs, Typography } from "mui";
import { FC, Fragment, useEffect, useState } from "react";
import Template from "components/Templates/Template";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import StarBorderPurple500OutlinedIcon from "@mui/icons-material/StarBorderPurple500Outlined";
import AddIcon from "@mui/icons-material/Add";
import styles from "modules/Templates/views/TemplatesView.module.scss";
import { useAppSelector } from "utils/hooks/storeHooks";
import { getAllTemplates } from "store/templates/thunks";
import { selectTemplates } from "store/templates/selectors";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import variables from "../../../styles/partials/_variables.module.scss";
import { setEmbedToken } from "store/session";

const TemplatesView: FC = () => {
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allTemplates = useAppSelector(selectTemplates);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const tabs = [
    {
      label: "Recent Snapshots",
      value: 0,
      icon: "Schecule",
    },
    {
      label: "Starred Snapshots",
      value: 1,
      icon: "Star",
    },
  ];
  useEffect(() => {
    dispatch(getAllTemplates());
  }, [dispatch]);

  // Solves bug when visualizing templates from different providers
  useEffect(() => {
    dispatch(setEmbedToken(""));
  }, [dispatch]);

  const starredTemplates = allTemplates.filter(
    (template) => template.isFavorite
  );
  return (
    <Fragment>
      <Box className={styles.pageContainer}>
        <Tabs
          className={styles.tabsPanel}
          orientation="vertical"
          sx={{
            color: variables.mainBlue,
          }}
          TabIndicatorProps={{
            sx: {
              left: 0,
            },
          }}
          value={value}
          onChange={handleChange}
        >
          {tabs.map(({ label, value, icon }) => (
            <Tab
              icon={
                icon === "Star" ? (
                  <StarBorderPurple500OutlinedIcon />
                ) : (
                  <AccessTimeOutlinedIcon />
                )
              }
              iconPosition="start"
              key={value}
              label={label}
              sx={{
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "0.9375rem",
                lineHeight: "22px",
                letterSpacing: "-0.00094rem",
                "&.MuiButtonBase-root.MuiTab-root.Mui-selected": {
                  fontWeight: 600,
                },
              }}
              value={value}
            />
          ))}
        </Tabs>
        <Box className={styles.pageContent}>
          <Box className={styles.title}>
            <Typography variant="h2">{tabs[value].label}</Typography>
          </Box>
          <Box>
            <Box className={styles.cardsContainer}>
              <Button
                className={styles.addTemplate}
                variant="containedSmall"
                onClick={() => navigate("/Providers")}
              >
                <Box className={styles.newTemplate}>
                  <AddIcon
                    sx={{
                      color: variables.backgroundWhite,
                      height: "48px",
                      width: "48px",
                    }}
                  />
                  New Template
                </Box>
              </Button>
              {tabs[value].label === "Recent Snapshots"
                ? allTemplates.map(({ file, name, id, isFavorite }, i) => (
                    <Template
                      id={id}
                      imgURL={file.data.url}
                      isStarred={isFavorite}
                      key={i}
                      templateInfo={allTemplates[i]}
                      title={name}
                    />
                  ))
                : starredTemplates.map(({ file, name, id, isFavorite }, i) => (
                    <Template
                      id={id}
                      imgURL={file.data.url}
                      isStarred={isFavorite}
                      key={i}
                      templateInfo={allTemplates[i]}
                      title={name}
                    />
                  ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default TemplatesView;
